// Documented absent-policy seeds; the server's effective baseline is authoritative.
export const SPACE_POLICY_SEEDS = Object.freeze({ underUsedPct: 80, hcBufferPct: 10, sfFloor: 150 });
export function fitPolicy(value = SPACE_POLICY_SEEDS) {
  const raw = typeof value === "number" ? { ...SPACE_POLICY_SEEDS, hcBufferPct: value } : value;
  if (!raw) return null;
  const p = { ...raw, tightPct: raw.tightPct ?? 100 - raw.hcBufferPct,
    nearLimitPct: raw.nearLimitPct ?? 100 - raw.hcBufferPct };
  if (![p.underUsedPct, p.tightPct, p.nearLimitPct, p.sfFloor].every(Number.isFinite)
    || p.underUsedPct < 0 || p.underUsedPct >= p.tightPct || p.tightPct > 100
    || p.nearLimitPct <= 0 || p.nearLimitPct > 100 || p.sfFloor <= 0) return null;
  return p;
}
